module.exports = __webpack_public_path__ + "img/android-icon-192x192.ee8ac75a.png";